<div class="user-management-container">
  <div class="header">
    <h1>User Management</h1>
    <p>Manage user permissions and settings</p>
  </div>

  <div class="content">
    <!-- Tab navigation -->
    <div class="tab-navigation">
      <button
        [class.active]="activeSection === 'list'"
        (click)="setActiveSection('list')">
        User List
      </button>
      <button
        [class.active]="activeSection === 'create'"
        (click)="setActiveSection('create')">
        Create New User
      </button>
      <button
        *ngIf="activeSection === 'edit-permissions'"
        [class.active]="activeSection === 'edit-permissions'">
        Edit User Permissions
      </button>
    </div>

    <!-- User List Section -->
    <div class="user-list-section" *ngIf="activeSection === 'list'">
      <h2>Client Users</h2>

      <div class="client-filter" *ngIf="isAdmin()">
        <label for="clientFilter">Filter by Client:</label>
        <select id="clientFilter" [(ngModel)]="selectedClientId" (change)="onClientFilterChange()">
          <option value="">All Clients</option>
          <option *ngFor="let client of clients" [value]="client.id">{{ client.name }}</option>
          <option value="no-client">Others (No Client)</option>
        </select>
      </div>

      <div class="loading-indicator" *ngIf="isLoading">
        <div class="spinner"></div>
        <p>Loading users...</p>
      </div>

      <div class="error-message" *ngIf="userListError">
        {{ userListError }}
        <button class="retry-button" (click)="loadUsers()">Retry</button>
      </div>

      <div class="user-list" *ngIf="!isLoading && !userListError && filteredUsers.length > 0">
        <div class="user-list-header">
          <div class="user-name">Username</div>
          <div class="user-email">Email</div>
          <div class="user-permissions">Permissions</div>
          <div class="user-status">Status</div>
          <div class="user-actions"></div>
        </div>

        <div class="user-row" *ngFor="let user of filteredUsers">
          <div class="user-name">{{ user.name }}</div>
          <div class="user-email">{{ user.email }}</div>
          <div class="user-permissions">{{ getPermissionsText(user.permissions, user.userRole) }}</div>
          <div class="user-status" [ngClass]="{'active': user.active, 'inactive': !user.active}">
            {{ user.active ? 'Active' : 'Inactive' }}
          </div>
          <div class="user-actions">
            <button class="action-button edit-button" title="Edit Permissions" (click)="openEditPermissions(user)">
              <mat-icon>edit</mat-icon>
            </button>
            <button class="action-button delete-button" title="Delete User" (click)="deleteUser(user)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="!isLoading && !userListError && filteredUsers.length === 0">
        <mat-icon>people_outline</mat-icon>
        <p>No users found for this client</p>
        <button class="primary-button" (click)="setActiveSection('create')">Add User</button>
      </div>
    </div>

    <!-- Edit Permissions Section -->
    <div class="edit-permissions-section" *ngIf="activeSection === 'edit-permissions' && selectedUser">
      <h2>Edit Permissions: {{ selectedUser.name }}</h2>

      <!-- Status message -->
      <div class="status-message success" *ngIf="permissionsUpdateMessage && permissionsUpdateMessage.type === 'success'">
        <mat-icon>check_circle</mat-icon>
        <span>{{ permissionsUpdateMessage.text }}</span>
      </div>

      <div class="status-message error" *ngIf="permissionsUpdateMessage && permissionsUpdateMessage.type === 'error'">
        <mat-icon>error</mat-icon>
        <span>{{ permissionsUpdateMessage.text }}</span>
      </div>

      <div class="user-info">
        <div class="info-item">
          <span class="label">Email:</span>
          <span class="value">{{ selectedUser.email }}</span>
        </div>
        <div class="info-item">
          <span class="label">Role:</span>
          <span class="value">{{ getUserRoleDisplay(selectedUser.userRole) }}</span>
        </div>
        <div class="info-item">
          <span class="label">Status:</span>
          <span class="value" [ngClass]="{'active-text': selectedUser.active, 'inactive-text': !selectedUser.active}">
            {{ selectedUser.active ? 'Active' : 'Inactive' }}
          </span>
        </div>
      </div>

      <div class="permission-selection">
        <h3>Select Project Permissions</h3>


        <div class="select-all-container">
          <div class="selected-cards-display">
            <!-- <button type="button" class="secondary-button" (click)="selectAllNodes()">
              {{ getSelectAllButtonText() }}
            </button> -->
            <div class="selected-cards-list">
              <div class="selected-card" *ngFor="let nodePath of selectedNodes.slice(0, 7)">
                <span class="card-name">{{ getNodeDisplayName(nodePath) }}</span>
                <button class="remove-card" (click)="removeSelectedCard(nodePath)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <div class="selected-card more-items" *ngIf="selectedNodes.length > 7">
                <span class="card-name">+{{ selectedNodes.length - 7 }} more</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Region Name Header -->
        <div class="region-header mb-4" *ngIf="navigationStack.length > 0">
          <h3 class="region-title">
            <img [src]="getIcon('Region')" class="region-icon">
            {{ navigationStack[navigationStack.length - 1].description }}
          </h3>
        </div>

        <div class="project-tree">
          <p class="helper-text">
            Select which projects this user should have access to:
          </p>

          <div class="region-header-2" *ngIf="hasNavigableNodes()">
            <p class="helper-text">
              *Сlick on the card to select specific types of projects
            </p>
          </div>
          <!-- Back Button -->
          <div class="back-button-container" *ngIf="showBackButton">
            <button class="btn btn-outline" (click)="navigateBack()">
              <i class="bi bi-arrow-left"></i>
              Back to Regions
            </button>
          </div>

          <div class="card-grid">
            <!-- Regular Card Grid -->
            <div class="card-item" *ngFor="let node of currentLevelNodes">
              <div class="card-content">
                <app-tree-card
                  [node]="node"
                  [isSelected]="isNodeSelected(node)"
                  (onNodeSelected)="navigateToNode($event)"
                  (onToggleChange)="toggleNodeSelection($event.node, $event.checked)">
                </app-tree-card>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="button" class="secondary-button" (click)="cancelEditPermissions()">Cancel</button>
          <button type="button" class="primary-button" (click)="saveUserPermissions()" [disabled]="isSavingPermissions">
            <span *ngIf="!isSavingPermissions">Save Permissions</span>
            <span *ngIf="isSavingPermissions">Saving...</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Create User Section -->
    <div class="create-user-section" *ngIf="activeSection === 'create'">
      <div class="form-user-management">
        <form #userForm="ngForm">
          <div class="form-row">
            <div class="form-group col-md-4">
              <label for="userName" class="form-label">Username</label>
              <input type="text" id="userName" name="userName" [(ngModel)]="newUser.userName" required class="form-control">
            </div>

            <div class="form-group col-md-4">
              <label for="email" class="form-label">Email</label>
              <input type="email" id="email" name="email" [(ngModel)]="newUser.email" required
                     (blur)="checkEmail()" placeholder="example@domain.com" class="form-control">
              <div *ngIf="emailError" class="error-message">{{ emailError }}</div>
            </div>
          </div>



          <div class="form-group" *ngIf="isAdmin()">
            <label for="userRole" class="form-label">User Role</label>
            <select id="userRole" name="userRole" [(ngModel)]="newUser.userRole" required class="form-control">
              <option value="Admin" title="Contains all permissions">Admin</option>
              <option value="CustomerAdmin" title="Access to all client data , there is available to create new users for his client">Customer</option>
              <option value="ModelExporter" title="Access to export models, there is not available to  create new users">Model Exporter</option>
              <option value="CustomerUser" title="Access to  part of client data">User</option>
              <option value="Test User" title="Access to all client data, but hidden from customer">Test User</option>
            </select>
          </div>

          <div class="form-group" *ngIf="isAdmin()">
            <label for="clientId" class="form-label">Client</label>
            <select id="clientId" name="clientId" [(ngModel)]="newUser.clientId" required class="form-control">
              <option value="">Select a client</option>
              <option *ngFor="let client of clients" [value]="client.id">{{ client.name }}</option>
            </select>
            <div class="loading-indicator" *ngIf="isLoadingClients">
              <div class="spinner"></div>
              <p>Loading clients...</p>
            </div>
          </div>

          <div class="form-group">
            <label>Project Access Permissions</label>
            <div class="select-all-container">

              <div class="selected-cards-display">
                <!-- <button type="button" class="secondary-button" (click)="selectAllNodes()">
                  {{ getSelectAllButtonText() }}
                </button> -->
                <div class="selected-cards-list">
                  <div class="selected-card" *ngFor="let nodePath of selectedNodes.slice(0, 7)">
                    <span class="card-name">{{ getNodeDisplayName(nodePath) }}</span>
                    <button class="remove-card" (click)="removeSelectedCard(nodePath)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                  <div class="selected-card more-items" *ngIf="selectedNodes.length > 7">
                    <span class="card-name">+{{ selectedNodes.length - 7 }} more</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Region Name Header -->
            <div class="region-header mb-4" *ngIf="navigationStack.length > 0">
              <h3 class="region-title">
                <img [src]="getIcon('Region')" class="region-icon">
                {{ navigationStack[navigationStack.length - 1].description }}
              </h3>
            </div>

            <div class="project-tree">
              <!-- Back Button -->
              <div class="back-button-container" *ngIf="showBackButton">
                <button class="btn btn-outline" (click)="navigateBack()">
                  <i class="bi bi-arrow-left"></i>
                  Back to Regions
                </button>
              </div>

              <p class="helper-text">
                Select which projects this user should have access to:
              </p>

              <div class="region-header-2" *ngIf="hasNavigableNodes()">
                <p class="helper-text">
                  *Сlick on the card to select specific types of projects
                </p>
              </div>

              <div class="card-grid">
                <!-- Regular Card Grid -->
                <div class="card-item" *ngFor="let node of currentLevelNodes">
                  <div class="card-content">
                    <app-tree-card
                      [node]="node"
                      [isSelected]="isNodeSelected(node)"
                      (onNodeSelected)="navigateToNode($event)"
                      (onToggleChange)="toggleNodeSelection($event.node, $event.checked)">
                    </app-tree-card>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="secondary-button" (click)="setActiveSection('list')">Cancel</button>
            <button  class="primary-button" (click)="onSubmit()" [disabled]="!userForm.valid || emailError">Create User</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
